import { LocalDate, Month } from "@js-joda/core";

export const ordinal = (n: number): string => {
  const mod10 = n % 10;
  const mod100 = n % 100;

  if (mod10 === 1 && mod100 !== 11) return `${n}st`;
  if (mod10 === 2 && mod100 !== 12) return `${n}nd`;
  if (mod10 === 3 && mod100 !== 13) return `${n}rd`;
  return `${n}th`;
};

export const monthName = (month: number) =>
  Month.of(month)
    .name()
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());

export const prettyDate = (date: LocalDate) => {
  const day = date.dayOfMonth();
  const month = date.monthValue();
  const year = date.year();

  return `${ordinal(day)} ${monthName(month)} ${year}`;
};

export const shortMonthName = (month: number) =>
  Month.of(month)
    .name()
    .slice(0, 3)
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());

export const shortDate = (date: LocalDate) => {
  const day = date.dayOfMonth();
  const month = shortMonthName(date.monthValue());
  const year = date.year();
  return `${ordinal(day)} ${month} ${String(year).slice(2)}`;
};

export const jsDateToLocalDate = (date: Date): LocalDate =>
  LocalDate.of(
    date.getFullYear(),
    date.getMonth() + 1, // JS months are 0-based
    date.getDate(),
  );

export const byType = <T extends { type: string }, K extends T["type"]>(
  type: K,
) => {
  return (x: T): x is Extract<T, { type: K }> => x.type === type;
};
